import React from "react";
import "../style.scss";
import sanitizeHtml from "sanitize-html";
import { useTheme } from "styled-components";

function Display({ title, titleStyle, footnotes }) {
  const theme = useTheme();

  return (
    <>
      {title !== "" && (
        <span
          style={{ color: theme.text.title }}
          className={`title-${titleStyle}`}
        >
          {title}
        </span>
      )}
      <ul
        style={{
          listStyleType: "decimal",
          margin: "0",
          paddingTop: "25px",
        }}
      >
        {footnotes.length &&
          footnotes.map((footnote) => (
            <li
              key={footnote.macroId}
              style={{
                color: theme.text.text,
                fontSize: "1em",
                wordBreak: "break-all",
              }}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(footnote.content),
              }}
            />
          ))}
      </ul>
    </>
  );
}

export default Display;
